export const FETCH_DAILY_STEPS_REPORTS = 'FETCH_DAILY_STEPS_REPORTS';
export const FETCH_DAILY_STEPS_REPORTS_FETCHING = 'FETCH_DAILY_STEPS_REPORTS_FETCHING';
export const FETCH_DAILY_STEPS_REPORTS_SUCCESS = 'FETCH_DAILY_STEPS_REPORTS_SUCCESS';
export const FETCH_DAILY_STEPS_REPORTS_FAIL = 'FETCH_DAILY_STEPS_REPORTS_FAIL';

export const FETCH_WEEKLY_STEPS_REPORTS = 'FETCH_WEEKLY_STEPS_REPORTS';
export const FETCH_WEEKLY_STEPS_REPORTS_FETCHING = 'FETCH_WEEKLY_STEPS_REPORTS_FETCHING';
export const FETCH_WEEKLY_STEPS_REPORTS_SUCCESS = 'FETCH_WEEKLY_STEPS_REPORTS_SUCCESS';
export const FETCH_WEEKLY_STEPS_REPORTS_FAIL = 'FETCH_WEEKLY_STEPS_REPORTS_FAIL';

export const FETCH_MONTHLY_STEPS_REPORTS = 'FETCH_MONTHLY_STEPS_REPORTS';
export const FETCH_MONTHLY_STEPS_REPORTS_FETCHING = 'FETCH_MONTHLY_STEPS_REPORTS_FETCHING';
export const FETCH_MONTHLY_STEPS_REPORTS_SUCCESS = 'FETCH_MONTHLY_STEPS_REPORTS_SUCCESS';
export const FETCH_MONTHLY_STEPS_REPORTS_FAIL = 'FETCH_MONTHLY_STEPS_REPORTS_FAIL';

export const SWITCH_STEPS_METRIC_PERIOD = 'SWITCH_STEPS_METRIC_PERIOD';
